import React, { PureComponent } from 'react';
import {
    View,
    StatusBar,
    Platform
} from 'react-native';

import {
    JDNativeSystem
} from '@jdreact/jdreact-core-lib';

if(JDNativeSystem.isIPhoneX){
    JDNativeSystem.statusBarHeight = 34;
}

/**
 * @param statusBarColor 状态栏颜色
 * @param compatibleStatusBarColor 保证兼容性的状态栏颜色，在安卓23以下无法改变状态栏文字颜色，一版需要非白色的背景色，建议#484848
 */
export default class StaBar extends PureComponent {
    render() {
        let { statusBarColor, compatibleStatusBarColor, barStyle } = this.props;
        if (Platform.OS === 'web') return null;
        return (
            <View>
                <StatusBar
                    translucent={true}
                    backgroundColor='transparent'
                    barStyle={barStyle || 'dark-content'}
                />
                {/* 状态栏占位 */}
                {/* iOS */}
                {!!(Platform.OS === 'ios') && (
                    <View style={{
                        height: JDNativeSystem.statusBarHeight,
                        backgroundColor: statusBarColor || '#fff'
                    }} />
                )}
                {/* android <23 */}
                {!!(Platform.OS === 'android' && Platform.Version < 23) && (
                    <View style={{
                        height: StatusBar.currentHeight,
                        backgroundColor: compatibleStatusBarColor || statusBarColor || '#484848'
                    }} />
                )}
                {/* android >=23 */}
                {!!(Platform.OS === 'android' && Platform.Version >= 23) && (
                    <View style={{
                        height: StatusBar.currentHeight,
                        backgroundColor: statusBarColor || '#fff'
                    }} />
                )}
            </View>
        );
    }
}
